import { useQuery } from 'react-query';
import { getNotifications } from '../redux/services/notifications/getNotifications';

export const useNotifications = () => {
  return useQuery(['notifications'], async () => {
    const response = await getNotifications();
    return response;
  });
};
